module.exports = __webpack_public_path__ + "img/box-arrow-up-right.f1c48db9.svg";